<template>
    <div class="option-wrapper">
      <div class="variable-input-field variable-input-field-value">
        <label-input
          :label="$t('variableManagement.value')"
          :type="'number'"
          v-model="labelValue"
          :error="valueError">
        </label-input>
      </div>
      <div class="variable-input-field variable-input-field-name margin-left-l">
        <label-input
          :label="$t('aggregateVariable.name')"
          v-model="labelName"
          :error="nameError"
          :errorMessage="$t('commons.mandatoryFieldMessage')"
          class="margin-right-s">
        </label-input>
      </div>
      <div class="variable-input-field colorpicker">
        <div>Color</div>
        <channel-color-picker
          :colorPreset="presetColors"
          :color="color"
          @color-change="onColorChange" />
      </div>
    </div>
</template>

<script>
import LabelInput from '@/components/shared/forms/LabelInput';

export default {
  name: 'CategoryOption',
  components: {
    LabelInput
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    valueError: {
      type: Boolean,
      default: false
    },
    nameError: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    labelValue: {
      handler: function (value) {
        this.emitInput();
      }
    },
    labelName: {
      handler: function (value) {
        this.emitInput();
      }
    }
  },
  data () {
    return {
      labelValue: null,
      labelName: '',
      color: {
        type: 'rgb',
        channels: [0, 0, 0]
      },
      presetColors: [
        '#ff3b38',
        '#ffa138',
        '#f9c900',
        '#6fcc2d',
        '#00d4ff',
        '#6161B1',
        '#666666',
        '#7B5529'
      ]
    };
  },
  created () {
    this.labelValue = String(this.value.value);
    this.labelName = this.value.name;
    if (typeof this.value.color === 'object') {
      this.value.color = this.parseColor();
    }
    if (this.value.color) {
      this.color = {
        type: 'rgb',
        channels: [
          parseInt(this.value.color.substring(1, 3), 16),
          parseInt(this.value.color.substring(3, 5), 16),
          parseInt(this.value.color.substring(5, 7), 16)
        ]
      };
    }
  },
  methods: {
    onColorChange (color) {
      this.color = color;
      this.emitInput();
    },
    emitInput () {
      const option = {
        value: Number(this.labelValue),
        name: this.labelName,
        color: this.parseColor()
      };
      this.$emit('input', option);
    },
    parseColor () {
      switch (this.color.type) {
        case 'cmyk':
          const r = 255 * (1 - this.color.channels[0]) * (1 - this.color.channels[3]);
          const g = 255 * (1 - this.color.channels[1]) * (1 - this.color.channels[3]);
          const b = 255 * (1 - this.color.channels[2]) * (1 - this.color.channels[3]);
          return '#' + decimal2Hex(r) + decimal2Hex(g) + decimal2Hex(b);

        case 'gray':
          return '#' + decimal2Hex(this.color.channels[0]) + decimal2Hex(this.color.channels[0]) + decimal2Hex(this.color.channels[0]);

        default:
          return '#' + decimal2Hex(this.color.channels[0]) + decimal2Hex(this.color.channels[1]) + decimal2Hex(this.color.channels[2]);
      }
    }
  }
};

const decimal2Hex = (decimal) => {
  const hex = decimal.toString(16);
  if (hex.length === 1) {
    return '0' + hex;
  }
  return hex;
};

</script>

<style lang="scss" scoped>
  @import "../../stylesheets/variables.scss";

  .variable-input-field {
    display: inline-block;
  }

  .variable-input-field-name {
    width: 60%;
    margin: 0 0;
  }

  .variable-input-field-value {
    min-width: 0px;
    width: 30%;
    float: left;
    margin: 0 $sp-margin 0 0;
  }

  .colorpicker {
    width: 5%;
    color: rgba(17, 17, 17, 0.5);
    vertical-align: top;
    margin-left: $sp-margin-small;
  }

  /deep/ .colorpicker {
    margin-right: $sp-margin;
  }

  /deep/ .sb-color_picker-current {
    height: 2.5rem;
    min-width: 4rem;
  }

  /deep/ .sb-color_picker-picker {
    z-index: 1;
  }

  /deep/ .sb-color_picker-preset>span {
    display: none;
  }

  /deep/ .sb-color_picker-preset_color:nth-of-type(7n+1) {
    margin-left: $sp-margin-smaller;
  }

  .option-wrapper {
    width: 76%;
    display: flex;
  }

</style>



// WEBPACK FOOTER //
// src/components/variable/CategoryOption.vue